require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-region-الشرق-الاوسط-وشمات-افريقيا.json") })
        }
      }, "path---ar-eg-region-الشرق-الاوسط-وشمات-افريقيا");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-region-الشرق-الاوسط-وشمات-افريقيا!./.cache/json/ar-eg-region-الشرق-الاوسط-وشمات-افريقيا.json
// module id = 443
// module chunks = 231608221292675